import { Vimeo } from 'vimeo'
import axios from 'axios'
import interceptors from './interceptors'

class VimeoService {
  api = null
  client = null
  uploadPercentage = 0

  constructor(baseURL, clientId, clientSecret, accessToken) {
    this.client = new Vimeo(clientId, clientSecret, accessToken)

    const headers = {
      Authorization: `bearer ${accessToken}`,
    }

    this.api = axios.create({ baseURL, headers })

    this.api.interceptors.response.use(res => res, interceptors.responseOnError)
  }

  uploadVideo(fileName, videoInfo) {
    return new Promise((resolve, reject) => {
      this.client.upload(
        fileName,
        videoInfo,
        async uri => {
          const url = await this.getUploadedVideoUrl(uri)
          const hash = url.split('/').pop()
          resolve(`${uri}?h=${hash}`)
        },
        this.uploadProgressCallback,
        reject,
      )
    })
  }

  uploadProgressCallback(bytesUploaded, bytesTotal) {
    return ((bytesUploaded / bytesTotal) * 100).toFixed(2)
  }

  processedVideo(uri) {
    return new Promise((resolve, reject) => {
      this.client.request(`${uri}fields=transcode.status`, (error, body) => {
        const statusResponse = body.transcode.status || 'in_progress'
        if (statusResponse === 'error') {
          reject(error)
        }

        resolve(statusResponse === 'complete')
      })
    })
  }

  getUploadedVideoUrl(uri) {
    return new Promise((resolve, reject) => {
      this.client.request(`${uri}?fields=link`, (error, body) => {
        if (error) {
          reject(error)
        }

        resolve(body.link)
      })
    })
  }

  async uploadThumbnail(uri, thumbnailUrl) {
    try {
      const thumbnail = await (await fetch(thumbnailUrl)).blob()

      const responseVideoUri = await this.api.get(uri)
      const videoThumbnailsUri =
        responseVideoUri.data.metadata.connections.pictures.uri

      const responseVideoThumbnailsUri = await this.api.post(videoThumbnailsUri)
      const thumbnailUploadLink = responseVideoThumbnailsUri.data.link
      const thumbnailUri = responseVideoThumbnailsUri.data.uri

      await axios.put(thumbnailUploadLink, thumbnail)

      return this.api.patch(thumbnailUri, { active: true })
    } catch (e) {
      return e
    }
  }

  deleteVideo(uri) {
    try {
      return this.api.delete(uri)
    } catch (e) {
      return e
    }
  }
}

export default VimeoService
